import React from "react";
import LoginForm from "./loginForm";
import styles from "./login.module.css";
import { ShipdayLogo, ShipdayText } from "./logos";

const LoginPageWrapper = () => {
  return (
    <div className={styles.fullPage}>
      <div className={styles.header}>
        <div className={styles.logoContainer}>
          <ShipdayLogo />
          <ShipdayText />
        </div>
      </div>
      <LoginForm />
    </div>
  );
};

export default LoginPageWrapper;
